import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';
import { FormattedMessage } from '@nykaa/intl-shared';

import Chevron from '@nykaa/ui-components/Icons/arrow-left';
import { getDataTestId } from 'shared/helpers';

interface PartialHeaderProps {
  title: string;
  onBack: () => void;
  fixAtTop?: boolean;
  isString?: boolean;
}

const Header = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 48px;
  padding: 0;
  background: #fff;
  color: #3f414d;
  ${({ theme }) => theme.typography.subTitleLarge};

  &.fixed {
    position: fixed;
    top: 0;
    z-index: 2;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  }
`;

const Back = styled.button`
  height: 48px;
  border: 0;
  background: transparent;
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing60} ${spacing.spacing60} ${spacing.spacing60} ${spacing.spacing80}`};

  &:focus {
    outline: none;
  }
`;

const Title = styled.span`
  display: inline-block;
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacing50} ${spacing.spacing60} ${spacing.spacing50} ${spacing.spacing0}`};
  ${({ theme }) => theme.typography.titleSmall};
  line-height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

const PartialHeader = ({
  title = '',
  onBack,
  fixAtTop = false,
  isString,
}: PartialHeaderProps) => {
  const theme: Theme = useTheme();
  return (
    <Header className={`${fixAtTop ? ' fixed' : ''}`}>
      <Back
        type="button"
        onClick={onBack}
        color={theme.brandPrimary}
        aria-label="Back"
        {...getDataTestId('new-buyers-sku-modal/back-button')}
      >
        <Chevron />
      </Back>
      <Title
        {...getDataTestId('new-buyers-sku-modal/title')}
        role="heading"
        aria-level={1}
      >
        {isString ? title : <FormattedMessage id={title} />}
      </Title>
    </Header>
  );
};

export default PartialHeader;
